<template>
  <div class="drawer-detail">
    <div class="search-row">
      <span class="label">关键面试决策人:</span>
      <span v-for="(hr, k) in project.interviewer" :key="k" class="link-text" style="margin:0 5px 5px 0" @click="showRadish(hr)">{{hr.姓名}}</span>
    </div>
    <div v-for="field in ['面试流程','面试辅导']" :key="field" class="field-type">
      <span class="label">{{translateTag[field]||field}}:</span>
      <div :class="[project[field]?'':'gray-text','value project-pre']">
        <p v-if="project[field]">{{project[field]}}</p>
        <p v-else>小阿暂时没有拿到有效数据，快来补充吧<span class="link-text" @click="quickEdit(field)"><i class="el-icon-edit-outline" style="cursor:pointer;margin: 0 4px;"></i>补充</span></p>
      </div>
    </div>
    <!-- <div class="field-type">
      <span class="label">对接hr:</span>
      <ul class="hrcardbox">
        <li v-for="item in project.contact" :key="item._id" class="hrcard">
          <div class="half-box">
            <span class="name">
              <span v-if="!item.rid">{{ item.姓名 || '' }}</span>
              <span v-else class="drawer-link" @click="showRadish({ id: item.rid })">{{ item.姓名 }}</span>
            </span>
            <div class="job-box">
              <p class="gray">{{ item.目前职位 }}</p>
              <p class="gray">{{ item.职级 }}</p>
            </div>
          </div>
          <div class="half-box contact">
            <p class="tel">{{ item.手机 }}</p>
            <p class="gray">{{ item.座机 }}</p>
            <p class="gray">{{ item.邮箱 }}</p>
          </div>
        </li>
      </ul>
    </div> -->
    <div class="field-type">
      <span class="label">面试地址:</span>
      <ul>
        <!-- <li v-for="(item, index) in project.面试地址" :key="index + 2" class="address-card" style="margin: 0 auto 6px;">
          <span class="address">{{ item.地址 }}</span> <span class="remark">{{ item.备注 }}</span>
        </li> -->
        <li class="address-card" style="margin: 0 auto 6px;">
          <span class="address">{{ project.面试地址word }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    project: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      fields: ['面试流程','关键面试人','面试辅导','面试地址word',],
      translateTag: {
        '面试流程':'项目面试流程',
        '面试辅导':'项目面试辅导',
      },
    }
  },
  methods: {
    showRadish(opts) {
      window.open(`${window.frontend}/#/radish-detail-blank/${opts._id}`, '_blank')
    },
    quickEdit(field){
      const { translateTag, project } = this
      this.$emit('quickEdit',{
        value: project[field],
        label:translateTag[field]||field,
        type:'input',
        confirmFunc:async(v)=>{
          try {
            await app.service('project').modify({ id: this.project._id, param:{ [field]: v } })
            this.$message.success(`修改成功`)
            this.$set(this.project,field,v)
          } catch (error) {
            this.$message.error(`modify:${error.message}`)
          }
        },
      })
    },
  },
}
</script>
<style scoped>
.flex {
  display: flex;
}
.value {
  background-color: #f2f2f2;
  padding: 10px;
}

.hrcardbox {
  overflow: auto;
  display: flex;
  flex-direction: column;
}
.hrcard {
  min-width: 200px;
  padding: 8px 12px;
  overflow: hidden;
  background-color: #fff;
  box-shadow: 0px 2px 8px 0px rgba(224, 224, 224, 0.5);
  border-radius: 6px;
  margin: 6px;
}
.hrcard .half-box {
  width: 50%;
  float: left;
  padding: 0 2px;
}
.hrcard .name {
  font-weight: 700;
  font-size: 16px;
  line-height: 26px;
  padding-right: 21px;
  text-align: left;
}
.hrcard .job-box {
  width: 100%;
}
.hrcard .job-box span {
  width: 50%;
}
.hrcard .tel {
  font-weight: 600;
}
.hrcard .contact p {
  word-break: break-word;
}
.hrcard .gray {
  color: #a4a3ac;
}
.address-card {
  padding: 0 10px;
}
.address-card::after {
  content: '';
  display: block;
  width: 100%;
  height: 1px;
  background-color: #c5c5c5;
  margin-top: 6px;
}
.address-card span {
  display: block;
}
.address-card .address {
  font-weight: 600;
  font-size: 14px;
}
.address-card .remark {
  font-size: 14px;
}
</style>
<style src="../../constant/css/detail.css" scoped></style>
